export default __webpack_public_path__ + "static/media/green_right.1039441b.svg";